<script setup>
defineProps({
  layoutName: {
    type: String,
    default: 'system',
  },
})
</script>

<template>
  <section class="client-layout client-layout--system" :data-layout="layoutName">
    <slot />
  </section>
</template>
